export default __webpack_public_path__ + "static/media/trans_pancreas.e2ed42d9.png";